import React, { useEffect, useState } from "react";
import "rsuite/dist/rsuite.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./global.scss";
import "./custom.scss";
import "./fonts.css";
import "./responsive.scss";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes";
import AuthMiddleware from "./routes/route";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useDispatch, useSelector } from "react-redux";
import Toast from "./components/common/Toast";
import {
  checkVerificationStatus,
  getCompanyInfo,
  intializeOrgnisation,
} from "store/actions/authSlice";
import PageNotFoundPage from "components/common/PageNotFoundPage";

function App() {
  const { isVisible, text, type } = useSelector((state) => state.Alert);
  const { brandInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [currentDomain, setCurrentDomain] = useState(window.location.hostname);
  const [showNotFound, setShowNotFound] = useState(false);

  // HANDLE THERE IF FOR AUTO LOGIN USER ON SUB DOMAIN
  useEffect(() => {}, []);

  const isAuthenticated = !!localStorage.getItem("authUser");

  useEffect(() => {
    if (isAuthenticated) {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const userId = authUser._id;
      dispatch(getCompanyInfo());

      if (authUser.hasSubscriptionEntry || authUser.isCompanyDetailsSaved) {
        dispatch(checkVerificationStatus({ userId }))
          .then((action) => {
            const { statusCode, success } = action?.payload || {};
            if (statusCode === 200 && success) {
              return true;
            }
          })
          .catch((err) => {});
      }
    }
  }, [dispatch]);

  // useEffect(() => {
  //   const excludedPaths = [
  //     "/accept-invite",
  //     "/set-new-password",
  //     "/autoRedirectUrl",
  //     "/sign-up",
  //     "/account/verification",
  //     "/verification-status",
  //     "/reset-password",
  //     "/reset-new-password",
  //     "/set-new-password",
  //   ];
  //   const currentPath = window.location.pathname;

  //   // Skip organization initialization if current route starts with any excluded path
  //   const shouldSkip = excludedPaths.some((path) =>
  //     currentPath.startsWith(path)
  //   );
  //   if (shouldSkip) return;
  //   const storedBrandInfo = sessionStorage.getItem("brandInfo");
  //   const storedBrandInfoResponse = sessionStorage.getItem("brandInfoResponse");

  //   // Check if domain has changed
  //   // if (currentDomain !== "hubhouse.applligentdemo.com") {
  //   if (currentDomain !== window.location.hostname) {
  //     sessionStorage.removeItem("brandInfoResponse"); // Clear response to force API call
  //     setCurrentDomain(window.location.hostname);
  //     setShowNotFound(false); // Reset NotFound state
  //   }

  //   if (!storedBrandInfo) {
  //     // const host = "moiz-khan-full-stack-dev.tod.com.sa";
  //     const host = window.location.hostname;

  //     // if (storedBrandInfoResponse !== "false") {
  //       dispatch(
  //         intializeOrgnisation({
  //           headers: {
  //             "x-browser-host": host,
  //           },
  //         })
  //       )
  //         .then((action) => {
  //           if (!action.payload?.success) {
  //             sessionStorage.setItem("brandInfoResponse", "false");
  //             setShowNotFound(true);
  //           }
  //         })
  //         .catch(() => {
  //           sessionStorage.setItem("brandInfoResponse", "false");
  //           setShowNotFound(true);
  //         });
  //     // } else {
  //     //   setShowNotFound(true);
  //     // }
  //   } else {
  //     if (storedBrandInfo !== undefined) {
  //       const parsedBrandInfo = JSON.parse(storedBrandInfo);
  //       dispatch({
  //         type: intializeOrgnisation.fulfilled.type,
  //         payload: {
  //           success: true,
  //           data: parsedBrandInfo,
  //         },
  //       });
  //       setShowNotFound(false);
  //     }
  //   }
  // }, [dispatch, currentDomain]);

  useEffect(() => {
    if (brandInfo?.theme?.themeColors?.primaryColor) {
      document.documentElement.style.setProperty(
        "--primary-color",
        brandInfo?.theme?.themeColors?.primaryColor
      );
      document.documentElement.style.setProperty(
        "--primary-color-2",
        brandInfo?.theme?.themeColors?.secondaryColor
      );
    }
    if (brandInfo?.theme?.faviconIcon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = brandInfo.theme.faviconIcon;
    }
  }, [brandInfo]);

  // if (showNotFound) {
  //   return <PageNotFoundPage />;
  // }

  return (
    <React.Fragment>
      {isVisible && <Toast isVisible={isVisible} text={text} type={type} />}

      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}

        {/* Auth Protected Routes */}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<AuthMiddleware>{route.element}</AuthMiddleware>}
            key={idx}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
